import { GlDisclosureDropdownItem, GlToggle } from '@gitlab/ui';
import { s__ } from '~/locale';
import { InternalEvents } from '~/tracking';
import HelpPopover from '~/vue_shared/components/help_popover.vue';
import { persistSidePanelPreference, alertPreferenceError } from '~/work_items/list/display_settings_preferences';
export default {
    name: 'WorkItemDisplaySettingsUserPreferences',
    components: {
        GlDisclosureDropdownItem,
        GlToggle,
        HelpPopover
    },
    mixins: [
        InternalEvents.mixin()
    ],
    i18n: {
        yourPreferences: s__('WorkItems|Your preferences'),
        openItemsInSidePanel: s__('WorkItems|Open items in side panel'),
        optionsAppliedToAllViews: s__('WorkItems|Options applied to all views')
    },
    props: {
        commonPreferences: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        fullPath: {
            type: String,
            required: true
        },
        workItemTypeId: {
            type: String,
            required: true
        },
        isSavedView: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            isLoading: false
        };
    },
    computed: {
        shouldOpenItemsInSidePanel () {
            return this.commonPreferences?.shouldOpenItemsInSidePanel ?? true;
        }
    },
    methods: {
        async toggleSidePanelPreference () {
            const isEnabled = this.shouldOpenItemsInSidePanel;
            this.isLoading = true;
            try {
                await persistSidePanelPreference({
                    apolloClient: this.$apollo,
                    namespace: this.fullPath,
                    workItemTypeId: this.workItemTypeId,
                    userPreferencesOnly: this.isSavedView,
                    shouldOpenItemsInSidePanel: !isEnabled
                });
                if (isEnabled) {
                    this.trackEvent('work_item_drawer_disabled');
                }
            } catch (error) {
                alertPreferenceError(error);
            } finally{
                this.isLoading = false;
            }
        }
    }
};
